var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('div',[_c('b-table',{staticClass:"table-banks-accounts",attrs:{"small":"","fields":_vm.fields,"items":_vm.items,"responsive":"sm","bordered":"","head-variant":"dark"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }